import { deriveSearchPricing } from "@/components/marketplace/map-search-product"
import type { Result as SearchProduct } from "@/generated/api/types.gen"
import { compareMoney, moneyFromNumber } from "@/lib/money"
import type { SearchQuery } from "@/lib/types/search"

type PriceBand = Pick<SearchQuery, "priceMin" | "priceMax">

export const withinPriceBand = ({ priceMin, priceMax }: PriceBand) => {
  if (priceMin === undefined && priceMax === undefined) return () => true
  return (product: SearchProduct) => {
    const { price } = deriveSearchPricing(product)
    return (
      (priceMin === undefined || compareMoney(price, moneyFromNumber(priceMin, price.currency)) >= 0) &&
      (priceMax === undefined || compareMoney(price, moneyFromNumber(priceMax, price.currency)) <= 0)
    )
  }
}
